import clsx from "clsx";
import BottomCard from "../../surface/BottomCard/BottomCard";
import { CardNavigationProps } from "./CardNavigation.types";
import InnerCardNavigation from "./InnerCardNavigation/InnerCardNavigation";

function CardNavigation({ className, style, ...innerCardNavigationProps }: CardNavigationProps) {
    return (
        <BottomCard className={clsx("card-navigation", className)} style={style}>
            <InnerCardNavigation {...innerCardNavigationProps} />
        </BottomCard>
    );
}

export default CardNavigation;
